import React, { useState } from 'react';
import useMasterThemes from '../../hooks/useMasterThemes';
import ThemeForm from '../../components/admin/themes/ThemeForm';
import ThemeDeleteDialog from '../../components/admin/themes/ThemeDeleteDialog';
import AdminPageHeader from '../../components/common/AdminPageHeader';
import LoadingSkeleton from '../../components/common/LoadingSkeleton';
import Toast from '../../components/common/Toast';

export default function AdminMasterThemes() {
  const { themes, loading, create, update, remove, get } = useMasterThemes();
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [toast, setToast] = useState({ visible: false, message: '', type: 'success' });
  const showToast = (m, t='success', d=4000) => { setToast({ visible: true, message: m, type: t }); setTimeout(() => setToast((s)=>({...s, visible:false})), d); };

  const handleCreate = () => { setEditing({ name: '', theme_data: {} }); setShowForm(true); };
  const handleEdit = async (id) => { const data = await get(id); setEditing(data); setShowForm(true); };

  const handleSave = async (payload) => {
    try {
      if (payload && payload.formData) {
        // multipart upload
        if (payload.id) {
          await update(payload.id, payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        } else {
          await create(payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
      } else {
        if (payload.id) await update(payload.id, payload);
        else await create(payload);
      }
      setShowForm(false);
      setEditing(null);
      showToast('Saved successfully', 'success');
    } catch (err) {
      console.error('Save error', err);
      showToast(err?.response?.data?.message || 'Error saving theme', 'error');
    }
  };

  const handleDelete = async (id) => {
    try {
      await remove(id);
      setDeleting(null);
      showToast('Theme deleted', 'success');
    } catch (err) {
      setDeleting({ ...deleting, error: err?.response?.data?.message || 'Failed to delete' });
    }
  };

  return (
    <div className="p-4">
      <AdminPageHeader title="Master Themes" actions={(<div className="flex items-center gap-2"><button onClick={handleCreate} className="px-3 py-2 bg-blue-600 text-white rounded">Create</button></div>)} />
      {loading ? <LoadingSkeleton /> : (
        <div className="overflow-x-auto border rounded-lg bg-white">
          <table className="w-full text-sm">
            <thead className="bg-gray-100 text-gray-700"><tr><th className="px-2 py-2 text-left">Name</th><th className="px-2 py-2 text-left">Description</th><th className="px-2 py-2 text-left">Companies</th><th className="px-2 py-2 text-left">Actions</th></tr></thead>
            <tbody>
              {Array.isArray(themes) && themes.length ? themes.map((t) => (
                <tr key={t.id} className="border-t hover:bg-gray-50">
                  <td className="px-2 py-2">{t.name}</td>
                  <td className="px-2 py-2">{t.description}</td>
                  <td className="px-2 py-2">{(t.companies||[]).length}</td>
                  <td className="px-2 py-2"><div className="flex gap-2"><button onClick={() => handleEdit(t.id)} className="px-3 py-1 bg-blue-600 text-white rounded">Edit</button><button onClick={() => setDeleting(t)} className="px-3 py-1 bg-red-600 text-white rounded">Delete</button></div></td>
                </tr>
              )) : (
                <tr><td colSpan="4" className="text-center py-4 text-gray-500">No themes yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {showForm && <ThemeForm theme={editing} onCancel={() => { setShowForm(false); setEditing(null); }} onSave={handleSave} />}
      {deleting && <ThemeDeleteDialog theme={deleting} onCancel={() => setDeleting(null)} onConfirm={() => handleDelete(deleting.id)} />}
      <Toast message={toast.message} type={toast.type} visible={toast.visible} />
    </div>
  );
}
